import type { Machine } from '@orgus/protocol';
import { machineLiveness } from '@orgus/protocol';
import { Check, Clock, X } from '@orgus/ui/icons';
import { Hive, cn, machineLabel, machineTone } from '@orgus/ui';
import { CARD_SURFACE } from './MachineCard.tsx';
import type { HiveCell } from '@orgus/ui';
import { MachineCardBody } from '../entities/EntityRef.tsx';

export const HIVE_ABOVE = 20;

const GLYPH = { online: <Check aria-hidden />, stale: <Clock aria-hidden />, offline: <X aria-hidden /> };

/** The dense view of a large fleet (DesignSystem 4.4): one cell per machine, load as fill, detail on hover. */
export function MachineHive({ machines, now, activeId, onOpen, liveSessions }: { machines: Machine[]; now: number; activeId: string | null; onOpen: (id: string) => void; liveSessions: (id: string) => number }) {
  const cells: HiveCell[] = machines.map((m) => {
    const l = machineLiveness(m, now);
    const n = liveSessions(m.id);
    return {
      key: m.id,
      tone: machineTone(m, now),
      glyph: GLYPH[l],
      fill: l === 'online' ? m.load : 0,
      label: `${m.name}, ${machineLabel(m, now).toLowerCase()}${l === 'online' ? `, load ${Math.round(m.load * 100)}%` : ''}, ${n} live session${n === 1 ? '' : 's'}`,
    };
  });
  return (
    <div className={cn(CARD_SURFACE, 'p-4')}>
      <Hive
        label={`${machines.length} machines`}
        cells={cells}
        activeKey={activeId}
        onOpen={onOpen}
        card={(id) => <MachineCardBody id={id} />}
        legend={[
          { tone: 'passed', label: 'Online', glyph: GLYPH.online },
          { tone: 'waiting', label: 'Not reporting', glyph: GLYPH.stale },
          { tone: 'offline', label: 'Offline', glyph: GLYPH.offline },
        ]}
      />
    </div>
  );
}
